module.exports = __webpack_public_path__ + "img/sv5on.ddc07f55.svg";